import React from 'react';
import {PageStore} from '../stores';

export default function(Component) {
  return class withStore extends React.Component {
    static displayName = `withStore(${Component.displayName})`;
    static propTypes = {};
    static defaultProps = {};
    /**
     * @constructor
     * @param {Object} props
     */
    constructor(props) {
      super(props);
      this.state = PageStore.getState();

      this.pageStoreUpdate = this.pageStoreUpdate.bind(this);
    }
    /**
     * Receive a new pageStore state
     * @param  {Object} store
     */
    pageStoreUpdate(store) {
      this.setState(store);
      this.forceUpdate();
    }
    /**
     * @override
     */
    componentDidMount() {
      PageStore.listen(this.pageStoreUpdate);
    }

    /**
     * @override
     */
    componentWillUnmount() {
      PageStore.unlisten(this.pageStoreUpdate);
    }

    /**
     * @override
     */
    render() {
      return (
        <Component
          {...this.props}
          store={this.state}
          isMenuOpen={this.state.MenuOpen.first()}
        />
      );
    }
  };
}
